import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const card = { background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' };
const inp = { padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box', width: '100%' };
const fmt = (d) => new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric' });

export default function AdminChangelog() {
  const [items, setItems] = useState([]);
  const [alleen, setAlleen] = useState('verborgen');
  const [nieuwTitel, setNieuwTitel] = useState('');
  const [nieuwTekst, setNieuwTekst] = useState('');
  const [melding, setMelding] = useState('');

  const laden = () => api.get('/changelog/admin').then((r) => setItems(r.data.items || [])).catch(() => setMelding('Laden mislukt'));
  useEffect(() => { laden(); }, []);

  const upd = async (id, velden) => {
    try { const r = await api.patch(`/changelog/admin/${id}`, velden); setItems((l) => l.map((i) => (i.id === id ? r.data : i))); }
    catch { setMelding('Opslaan mislukt'); }
  };
  const del = async (id) => { if (!window.confirm('Verwijderen?')) return; await api.delete(`/changelog/admin/${id}`); setItems((l) => l.filter((i) => i.id !== id)); };
  const add = async () => {
    if (!nieuwTitel.trim()) return;
    try { await api.post('/changelog/admin', { titel: nieuwTitel, tekst: nieuwTekst }); setNieuwTitel(''); setNieuwTekst(''); laden(); }
    catch { setMelding('Opslaan mislukt'); }
  };

  const lijst = items.filter((i) => alleen === 'alle' || (alleen === 'verborgen' ? !i.zichtbaar : i.zichtbaar));

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1100 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 30 }}>🆕 Wat is nieuw</h1>
        <span style={{ color: '#6b7280', fontSize: 14 }}>{melding || `${items.filter((i) => i.zichtbaar).length} zichtbaar · ${items.filter((i) => !i.zichtbaar).length} verborgen`}</span>
      </div>

      <div style={{ ...card, marginBottom: 20 }}>
        <div style={{ fontWeight: 600, marginBottom: 10 }}>Handmatige entry</div>
        <input placeholder="Titel (wat zien gebruikers)" value={nieuwTitel} onChange={(e) => setNieuwTitel(e.target.value)} style={inp} />
        <textarea rows={2} placeholder="Toelichting (optioneel)" value={nieuwTekst} onChange={(e) => setNieuwTekst(e.target.value)} style={{ ...inp, marginTop: 8, resize: 'vertical' }} />
        <button onClick={add} style={{ marginTop: 10, background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontWeight: 600, cursor: 'pointer' }}>Toevoegen (direct zichtbaar)</button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        {[['verborgen', 'Nog te beoordelen'], ['zichtbaar', 'Zichtbaar'], ['alle', 'Alles']].map(([k, l]) => (
          <button key={k} onClick={() => setAlleen(k)} style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid #e5e7eb', cursor: 'pointer', background: alleen === k ? '#111827' : '#fff', color: alleen === k ? '#fff' : '#374151', fontSize: 13 }}>{l}</button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {lijst.length === 0 && <div style={{ ...card, color: '#6b7280', textAlign: 'center' }}>Niks in deze lijst.</div>}
        {lijst.map((i) => (
          <div key={i.id} style={{ ...card, padding: '14px 18px', display: 'grid', gridTemplateColumns: '90px 1fr auto', gap: 14, alignItems: 'start', opacity: i.zichtbaar ? 1 : 0.85 }}>
            <div style={{ fontSize: 12, color: '#6b7280', paddingTop: 8 }}>{fmt(i.datum)}<br /><span style={{ fontSize: 11 }}>{i.bron}{i.commit_hash ? ' ' + i.commit_hash.slice(0, 7) : ''}</span></div>
            <div>
              <input defaultValue={i.titel} onBlur={(e) => e.target.value !== i.titel && upd(i.id, { titel: e.target.value })} style={{ ...inp, fontWeight: 600 }} />
              <textarea rows={1} defaultValue={i.tekst || ''} placeholder="Toelichting voor gebruikers" onBlur={(e) => (e.target.value || '') !== (i.tekst || '') && upd(i.id, { tekst: e.target.value })} style={{ ...inp, marginTop: 6, resize: 'vertical', fontSize: 13 }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <button onClick={() => upd(i.id, { zichtbaar: !i.zichtbaar })} style={{ padding: '7px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13, background: i.zichtbaar ? '#d1fae5' : '#3b82f6', color: i.zichtbaar ? '#065f46' : '#fff' }}>{i.zichtbaar ? '✓ Zichtbaar' : 'Zichtbaar maken'}</button>
              <button onClick={() => del(i.id)} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', color: '#9ca3af', cursor: 'pointer', fontSize: 12 }}>Verwijder</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
